module.exports = __webpack_public_path__ + "img/household-goods.fe8dc1df.png";